function menuLinkTrimmer(linkString) {
    return linkString.replace("https://smartall-mid-web.wjthinkbig.com", "");
}

export default menuLinkTrimmer;
